// extracted by mini-css-extract-plugin
export default {"wrapper":"default_wrapper__gycaC","header":"default_header__sBSDf","columns":"default_columns__oQSoe","column":"default_column__R-HG+"};